import { mainApi, queryFnNotifyWrapper } from 'modules/api';

import { authCacheTags } from '../authCacheTags';
import { getIotaProvider } from '../utils/getIotaProvider';
import { removeStoredWalletId } from '../utils/storeWalletId';

interface Args {
  walletId: string;
}

export const {
  useDisconnectMutation,
  endpoints: { disconnect },
} = mainApi.injectEndpoints({
  endpoints: build => ({
    disconnect: build.mutation<null, Args>({
      queryFn: queryFnNotifyWrapper<Args, never, null>(async ({ walletId }) => {
        const provider = await getIotaProvider(walletId);
        await provider.disconnect();

        return { data: null };
      }),
      async onQueryStarted(_args, { queryFulfilled }) {
        await queryFulfilled;

        removeStoredWalletId();
      },
      invalidatesTags: [authCacheTags.disconnect],
    }),
  }),
});
